module.exports = __webpack_public_path__ + "assets/checkout-c2a428.svg";